export class Controller {

    /** @ngInject */
    constructor($state, Alert) {
        this.$state = $state;
        this.Alert = Alert;
    }

    $onInit() {
        this.$state.go('^')
            .then(() => this.Alert('danger', 'company.sms-services.paypal-cancelled.payment-cancelled'));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/paypal-cancelled/paypal-cancelled.controller.js